(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bs-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-bak"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  const ATS_GIFT_OPTION_LINE_PREFIX = 'Gift Option - ';

  function atsBuildManagedGiftOptionsNote(cart) {
    const lines = [];

    cart.items.forEach((item) => {
      const properties = item.properties || {};
      const wrapping = properties['Gift Wrapping Design'] || properties['Gift Wrapping Selection'];
      const card = properties['Greeting Card Design'] || properties['Greeting Card Selection'];

      if (wrapping) {
        lines.push(`${ATS_GIFT_OPTION_LINE_PREFIX}${item.product_title} - Wrapping: ${wrapping}`);
      }

      if (card) {
        lines.push(`${ATS_GIFT_OPTION_LINE_PREFIX}${item.product_title} - Card: ${card}`);
      }
    });

    return lines.join('\n');
  }

  function atsMergeManagedGiftOptionsNote(existingNote, managedNote) {
    const preservedLines = (existingNote || '')
      .split('\n')
      .map((line) => line.trimEnd())
      .filter((line) => line && !line.startsWith(ATS_GIFT_OPTION_LINE_PREFIX));

    if (managedNote) {
      preservedLines.push(...managedNote.split('\n'));
    }

    return preservedLines.join('\n');
  }

  async function atsSyncManagedGiftOptionsNote(textarea) {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const managedNote = atsBuildManagedGiftOptionsNote(cart);
      const currentNote = textarea ? textarea.value : (cart.note || '');
      const mergedNote = atsMergeManagedGiftOptionsNote(currentNote, managedNote);

      if (textarea && textarea.value !== mergedNote) {
        textarea.value = mergedNote;
      }

      if (!textarea && !managedNote) return;
      if (!textarea && currentNote === mergedNote) return;
      if (textarea && currentNote === mergedNote) return;

      const body = JSON.stringify({ note: mergedNote });
      await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    } catch (error) {
      console.warn('ATS gift option note sync failed.', error);
    }
  }

  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.textarea = this.querySelector('textarea[name="note"]');

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300));

      atsSyncManagedGiftOptionsNote(this.textarea);
    }
  }

  customElements.define('cart-note', CartNote);

  if (!document.querySelector('cart-note') && document.getElementById('cart')) {
    atsSyncManagedGiftOptionsNote(null);
  }

   const cartCheckoutButton = document.querySelector('.cart__checkout-button');
   if (cartCheckoutButton) {
     cartCheckoutButton.addEventListener('click', async (event) => {
       event.preventDefault();

      const cartNoteElement = document.querySelector('cart-note textarea[name="note"]');
      await atsSyncManagedGiftOptionsNote(cartNoteElement);

       const cartForm = document.getElementById('cart');
       if (cartForm) {
         if (typeof cartForm.requestSubmit === 'function') {
           cartForm.requestSubmit(cartCheckoutButton);
         } else {
           const checkoutInput = document.createElement('input');
           checkoutInput.type = 'hidden';
           checkoutInput.name = 'checkout';
           checkoutInput.value = cartCheckoutButton.value || '';
           cartForm.appendChild(checkoutInput);
           cartForm.submit();
           checkoutInput.remove();
         }
       }
     });
   }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-2-columns-left"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-2-columns-right"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
